module.exports = __webpack_public_path__ + "static/media/doubt.1a7bfccd.png";